import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, take, mapTo } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Currency = /*#__PURE__*/function (Currency) {
  Currency[Currency["USD"] = 0] = "USD";
  Currency[Currency["CAD"] = 1] = "CAD";
  Currency[Currency["EUR"] = 2] = "EUR";
  Currency[Currency["AUD"] = 3] = "AUD";
  Currency[Currency["GBP"] = 4] = "GBP";
  Currency[Currency["NZD"] = 5] = "NZD";
  Currency[Currency["ZAR"] = 6] = "ZAR";
  return Currency;
}(Currency || {});
var DurationPeriod = /*#__PURE__*/function (DurationPeriod) {
  DurationPeriod[DurationPeriod["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  DurationPeriod[DurationPeriod["MONTH"] = 1] = "MONTH";
  DurationPeriod[DurationPeriod["YEAR"] = 2] = "YEAR";
  DurationPeriod[DurationPeriod["DAY"] = 3] = "DAY";
  DurationPeriod[DurationPeriod["WEEK"] = 4] = "WEEK";
  return DurationPeriod;
}(DurationPeriod || {});
var RevenuePeriod = /*#__PURE__*/function (RevenuePeriod) {
  RevenuePeriod[RevenuePeriod["ONETIME"] = 0] = "ONETIME";
  RevenuePeriod[RevenuePeriod["DAILY"] = 1] = "DAILY";
  RevenuePeriod[RevenuePeriod["WEEKLY"] = 2] = "WEEKLY";
  RevenuePeriod[RevenuePeriod["BIWEEKLY"] = 3] = "BIWEEKLY";
  RevenuePeriod[RevenuePeriod["MONTHLY"] = 4] = "MONTHLY";
  RevenuePeriod[RevenuePeriod["YEARLY"] = 5] = "YEARLY";
  return RevenuePeriod;
}(RevenuePeriod || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var MEDDICSection = /*#__PURE__*/function (MEDDICSection) {
  MEDDICSection[MEDDICSection["MEDDIC_SECTION_UNDEFINED"] = 0] = "MEDDIC_SECTION_UNDEFINED";
  MEDDICSection[MEDDICSection["MEDDIC_SECTION_METRICS"] = 1] = "MEDDIC_SECTION_METRICS";
  MEDDICSection[MEDDICSection["MEDDIC_SECTION_ECONOMIC_BUYER"] = 2] = "MEDDIC_SECTION_ECONOMIC_BUYER";
  MEDDICSection[MEDDICSection["MEDDIC_SECTION_DECISION_CRITERIA"] = 3] = "MEDDIC_SECTION_DECISION_CRITERIA";
  MEDDICSection[MEDDICSection["MEDDIC_SECTION_DECISION_PROCESS"] = 4] = "MEDDIC_SECTION_DECISION_PROCESS";
  MEDDICSection[MEDDICSection["MEDDIC_SECTION_IDENTIFY_PAIN"] = 5] = "MEDDIC_SECTION_IDENTIFY_PAIN";
  MEDDICSection[MEDDICSection["MEDDIC_SECTION_CHAMPION_SCORE"] = 6] = "MEDDIC_SECTION_CHAMPION_SCORE";
  MEDDICSection[MEDDICSection["MEDDIC_SECTION_COMPETITION"] = 7] = "MEDDIC_SECTION_COMPETITION";
  MEDDICSection[MEDDICSection["MEDDIC_SECTION_PAPER_PROCESS"] = 8] = "MEDDIC_SECTION_PAPER_PROCESS";
  return MEDDICSection;
}(MEDDICSection || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ClientOrigin = /*#__PURE__*/function (ClientOrigin) {
  ClientOrigin[ClientOrigin["CLIENT_ORIGIN_UNSET"] = 0] = "CLIENT_ORIGIN_UNSET";
  ClientOrigin[ClientOrigin["CLIENT_ORIGIN_SALES_CENTER"] = 1] = "CLIENT_ORIGIN_SALES_CENTER";
  ClientOrigin[ClientOrigin["CLIENT_ORIGIN_PARTNER_CENTER"] = 2] = "CLIENT_ORIGIN_PARTNER_CENTER";
  return ClientOrigin;
}(ClientOrigin || {});
var ClosedLostReasonOption = /*#__PURE__*/function (ClosedLostReasonOption) {
  ClosedLostReasonOption[ClosedLostReasonOption["PRICE"] = 0] = "PRICE";
  ClosedLostReasonOption[ClosedLostReasonOption["NO_BUDGET"] = 1] = "NO_BUDGET";
  ClosedLostReasonOption[ClosedLostReasonOption["LOST_TO_COMPETITOR"] = 2] = "LOST_TO_COMPETITOR";
  ClosedLostReasonOption[ClosedLostReasonOption["NOT_READY"] = 3] = "NOT_READY";
  ClosedLostReasonOption[ClosedLostReasonOption["OTHER"] = 4] = "OTHER";
  return ClosedLostReasonOption;
}(ClosedLostReasonOption || {});
var OpportunityRevenuePeriod = /*#__PURE__*/function (OpportunityRevenuePeriod) {
  OpportunityRevenuePeriod[OpportunityRevenuePeriod["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  OpportunityRevenuePeriod[OpportunityRevenuePeriod["SELECTED_MONTH"] = 1] = "SELECTED_MONTH";
  return OpportunityRevenuePeriod;
}(OpportunityRevenuePeriod || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["ASCENDING"] = 0] = "ASCENDING";
  SortDirection[SortDirection["DESCENDING"] = 1] = "DESCENDING";
  return SortDirection;
}(SortDirection || {});
var ListOpportunitiesRequestSortField = /*#__PURE__*/function (ListOpportunitiesRequestSortField) {
  ListOpportunitiesRequestSortField[ListOpportunitiesRequestSortField["PROJECTED_FIRST_YEAR_VALUE"] = 0] = "PROJECTED_FIRST_YEAR_VALUE";
  ListOpportunitiesRequestSortField[ListOpportunitiesRequestSortField["PROBABILITY"] = 1] = "PROBABILITY";
  ListOpportunitiesRequestSortField[ListOpportunitiesRequestSortField["CREATED"] = 2] = "CREATED";
  ListOpportunitiesRequestSortField[ListOpportunitiesRequestSortField["EXPECTED_CLOSE"] = 3] = "EXPECTED_CLOSE";
  ListOpportunitiesRequestSortField[ListOpportunitiesRequestSortField["NAME"] = 4] = "NAME";
  ListOpportunitiesRequestSortField[ListOpportunitiesRequestSortField["LAST_ACTIVITY"] = 5] = "LAST_ACTIVITY";
  ListOpportunitiesRequestSortField[ListOpportunitiesRequestSortField["LAST_CONNECTED"] = 6] = "LAST_CONNECTED";
  ListOpportunitiesRequestSortField[ListOpportunitiesRequestSortField["ACTUAL_CLOSE"] = 7] = "ACTUAL_CLOSE";
  ListOpportunitiesRequestSortField[ListOpportunitiesRequestSortField["PIPELINE_STAGE"] = 8] = "PIPELINE_STAGE";
  ListOpportunitiesRequestSortField[ListOpportunitiesRequestSortField["MEDDIC"] = 9] = "MEDDIC";
  ListOpportunitiesRequestSortField[ListOpportunitiesRequestSortField["ASSIGNED_DATE"] = 10] = "ASSIGNED_DATE";
  return ListOpportunitiesRequestSortField;
}(ListOpportunitiesRequestSortField || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var GoalType = /*#__PURE__*/function (GoalType) {
  GoalType[GoalType["GOAL_TYPE_UNSPECIFIED"] = 0] = "GOAL_TYPE_UNSPECIFIED";
  GoalType[GoalType["REVENUE"] = 1] = "REVENUE";
  GoalType[GoalType["NEW_REVENUE"] = 2] = "NEW_REVENUE";
  GoalType[GoalType["EXPANSION_REVENUE"] = 3] = "EXPANSION_REVENUE";
  GoalType[GoalType["EMAIL"] = 4] = "EMAIL";
  GoalType[GoalType["CALL"] = 5] = "CALL";
  GoalType[GoalType["MEETING"] = 6] = "MEETING";
  GoalType[GoalType["OPPORTUNITY"] = 7] = "OPPORTUNITY";
  return GoalType;
}(GoalType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ListGoalsRequestSortDirection = /*#__PURE__*/function (ListGoalsRequestSortDirection) {
  ListGoalsRequestSortDirection[ListGoalsRequestSortDirection["ASCENDING"] = 0] = "ASCENDING";
  ListGoalsRequestSortDirection[ListGoalsRequestSortDirection["DESCENDING"] = 1] = "DESCENDING";
  return ListGoalsRequestSortDirection;
}(ListGoalsRequestSortDirection || {});
var ListGoalsRequestSortField = /*#__PURE__*/function (ListGoalsRequestSortField) {
  ListGoalsRequestSortField[ListGoalsRequestSortField["SORT_FIELD_UNSET"] = 0] = "SORT_FIELD_UNSET";
  ListGoalsRequestSortField[ListGoalsRequestSortField["SORT_FIELD_CREATED"] = 1] = "SORT_FIELD_CREATED";
  return ListGoalsRequestSortField;
}(ListGoalsRequestSortField || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class LineItemAppKey {
  static fromProto(proto) {
    let m = new LineItemAppKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.packageInstanceId !== 'undefined') {
      toReturn['packageInstanceId'] = this.packageInstanceId;
    }
    return toReturn;
  }
}
class BillingPeriod {
  static fromProto(proto) {
    let m = new BillingPeriod();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class Cost {
  static fromProto(proto) {
    let m = new Cost();
    m = Object.assign(m, proto);
    if (proto.customPrice) {
      m.customPrice = parseInt(proto.customPrice, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customPrice !== 'undefined') {
      toReturn['customPrice'] = this.customPrice;
    }
    return toReturn;
  }
}
class CustomPriceMapping {
  static fromProto(proto) {
    let m = new CustomPriceMapping();
    m = Object.assign(m, proto);
    if (proto.customPrice) {
      m.customPrice = parseInt(proto.customPrice, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.customPrice !== 'undefined') {
      toReturn['customPrice'] = this.customPrice;
    }
    return toReturn;
  }
}
class Duration {
  static fromProto(proto) {
    let m = new Duration();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    if (proto.duration) {
      m.duration = enumStringToValue$8(DurationPeriod, proto.duration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.duration !== 'undefined') {
      toReturn['duration'] = this.duration;
    }
    return toReturn;
  }
}
class LineItem {
  static fromProto(proto) {
    let m = new LineItem();
    m = Object.assign(m, proto);
    if (proto.appKey) {
      m.appKey = LineItemAppKey.fromProto(proto.appKey);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$8(Currency, proto.currency);
    }
    if (proto.initialRevenue) {
      m.initialRevenue = Revenue.fromProto(proto.initialRevenue);
    }
    if (proto.currentRevenue) {
      m.currentRevenue = Revenue.fromProto(proto.currentRevenue);
    }
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    if (proto.cost) {
      m.cost = Cost.fromProto(proto.cost);
    }
    if (proto.customPrices) {
      m.customPrices = proto.customPrices.map(CustomPriceMapping.fromProto);
    }
    if (proto.billingPeriod) {
      m.billingPeriod = BillingPeriod.fromProto(proto.billingPeriod);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appKey !== 'undefined' && this.appKey !== null) {
      toReturn['appKey'] = 'toApiJson' in this.appKey ? this.appKey.toApiJson() : this.appKey;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.initialRevenue !== 'undefined' && this.initialRevenue !== null) {
      toReturn['initialRevenue'] = 'toApiJson' in this.initialRevenue ? this.initialRevenue.toApiJson() : this.initialRevenue;
    }
    if (typeof this.currentRevenue !== 'undefined' && this.currentRevenue !== null) {
      toReturn['currentRevenue'] = 'toApiJson' in this.currentRevenue ? this.currentRevenue.toApiJson() : this.currentRevenue;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.cost !== 'undefined' && this.cost !== null) {
      toReturn['cost'] = 'toApiJson' in this.cost ? this.cost.toApiJson() : this.cost;
    }
    if (typeof this.customPrices !== 'undefined' && this.customPrices !== null) {
      toReturn['customPrices'] = 'toApiJson' in this.customPrices ? this.customPrices.toApiJson() : this.customPrices;
    }
    if (typeof this.billingPeriod !== 'undefined' && this.billingPeriod !== null) {
      toReturn['billingPeriod'] = 'toApiJson' in this.billingPeriod ? this.billingPeriod.toApiJson() : this.billingPeriod;
    }
    if (typeof this.autoBillable !== 'undefined') {
      toReturn['autoBillable'] = this.autoBillable;
    }
    if (typeof this.nonBillable !== 'undefined') {
      toReturn['nonBillable'] = this.nonBillable;
    }
    if (typeof this.taxRateIds !== 'undefined') {
      toReturn['taxRateIds'] = this.taxRateIds;
    }
    return toReturn;
  }
}
class Revenue {
  static fromProto(proto) {
    let m = new Revenue();
    m = Object.assign(m, proto);
    if (proto.revenueComponents) {
      m.revenueComponents = proto.revenueComponents.map(RevenueComponent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.revenueComponents !== 'undefined' && this.revenueComponents !== null) {
      toReturn['revenueComponents'] = 'toApiJson' in this.revenueComponents ? this.revenueComponents.toApiJson() : this.revenueComponents;
    }
    return toReturn;
  }
}
class RevenueComponent {
  static fromProto(proto) {
    let m = new RevenueComponent();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    if (proto.period) {
      m.period = enumStringToValue$8(RevenuePeriod, proto.period);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.period !== 'undefined') {
      toReturn['period'] = this.period;
    }
    if (typeof this.isStartingRevenue !== 'undefined') {
      toReturn['isStartingRevenue'] = this.isStartingRevenue;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class MEDDICScores {
  static fromProto(proto) {
    let m = new MEDDICScores();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metric !== 'undefined') {
      toReturn['metric'] = this.metric;
    }
    if (typeof this.economicBuyer !== 'undefined') {
      toReturn['economicBuyer'] = this.economicBuyer;
    }
    if (typeof this.decisionCriteria !== 'undefined') {
      toReturn['decisionCriteria'] = this.decisionCriteria;
    }
    if (typeof this.decisionProcess !== 'undefined') {
      toReturn['decisionProcess'] = this.decisionProcess;
    }
    if (typeof this.identifyPain !== 'undefined') {
      toReturn['identifyPain'] = this.identifyPain;
    }
    if (typeof this.champion !== 'undefined') {
      toReturn['champion'] = this.champion;
    }
    if (typeof this.competition !== 'undefined') {
      toReturn['competition'] = this.competition;
    }
    if (typeof this.paperProcess !== 'undefined') {
      toReturn['paperProcess'] = this.paperProcess;
    }
    return toReturn;
  }
}
class ScoringScore {
  static fromProto(proto) {
    let m = new ScoringScore();
    m = Object.assign(m, proto);
    if (proto.section) {
      m.section = enumStringToValue$7(MEDDICSection, proto.section);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sectionId !== 'undefined') {
      toReturn['sectionId'] = this.sectionId;
    }
    if (typeof this.scoreValue !== 'undefined') {
      toReturn['scoreValue'] = this.scoreValue;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.section !== 'undefined') {
      toReturn['section'] = this.section;
    }
    return toReturn;
  }
}
class Scoring {
  static fromProto(proto) {
    let m = new Scoring();
    m = Object.assign(m, proto);
    if (proto.scores) {
      m.scores = proto.scores.map(ScoringScore.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scores !== 'undefined' && this.scores !== null) {
      toReturn['scores'] = 'toApiJson' in this.scores ? this.scores.toApiJson() : this.scores;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Forecasting {
  static fromProto(proto) {
    let m = new Forecasting();
    m = Object.assign(m, proto);
    if (proto.revenueInMonth) {
      m.revenueInMonth = RevenueInMonth.fromProto(proto.revenueInMonth);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.revenueInMonth !== 'undefined' && this.revenueInMonth !== null) {
      toReturn['revenueInMonth'] = 'toApiJson' in this.revenueInMonth ? this.revenueInMonth.toApiJson() : this.revenueInMonth;
    }
    return toReturn;
  }
}
class RevenueInMonth {
  static fromProto(proto) {
    let m = new RevenueInMonth();
    m = Object.assign(m, proto);
    if (proto.initialRevenue) {
      m.initialRevenue = parseInt(proto.initialRevenue, 10);
    }
    if (proto.recurringRevenue) {
      m.recurringRevenue = parseInt(proto.recurringRevenue, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.initialRevenue !== 'undefined') {
      toReturn['initialRevenue'] = this.initialRevenue;
    }
    if (typeof this.recurringRevenue !== 'undefined') {
      toReturn['recurringRevenue'] = this.recurringRevenue;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Attachment {
  static fromProto(proto) {
    let m = new Attachment();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attachmentId !== 'undefined') {
      toReturn['attachmentId'] = this.attachmentId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class CSVExports {
  static fromProto(proto) {
    let m = new CSVExports();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunities !== 'undefined') {
      toReturn['opportunities'] = this.opportunities;
    }
    if (typeof this.opportunityHistory !== 'undefined') {
      toReturn['opportunityHistory'] = this.opportunityHistory;
    }
    return toReturn;
  }
}
class CSVFormatOptions {
  static fromProto(proto) {
    let m = new CSVFormatOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    return toReturn;
  }
}
class ClosedLostReason {
  static fromProto(proto) {
    let m = new ClosedLostReason();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = enumStringToValue$5(ClosedLostReasonOption, proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class CurrentOpportunityPoint {
  static fromProto(proto) {
    let m = new CurrentOpportunityPoint();
    m = Object.assign(m, proto);
    if (proto.day) {
      m.day = new Date(proto.day);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.day !== 'undefined' && this.day !== null) {
      toReturn['day'] = 'toApiJson' in this.day ? this.day.toApiJson() : this.day;
    }
    if (typeof this.openOpportunities !== 'undefined') {
      toReturn['openOpportunities'] = this.openOpportunities;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    return toReturn;
  }
}
class DateRangeFilter {
  static fromProto(proto) {
    let m = new DateRangeFilter();
    m = Object.assign(m, proto);
    if (proto.beginRange) {
      m.beginRange = new Date(proto.beginRange);
    }
    if (proto.endRange) {
      m.endRange = new Date(proto.endRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.beginRange !== 'undefined' && this.beginRange !== null) {
      toReturn['beginRange'] = 'toApiJson' in this.beginRange ? this.beginRange.toApiJson() : this.beginRange;
    }
    if (typeof this.endRange !== 'undefined' && this.endRange !== null) {
      toReturn['endRange'] = 'toApiJson' in this.endRange ? this.endRange.toApiJson() : this.endRange;
    }
    return toReturn;
  }
}
class ListOpportunitiesRequestFilters {
  static fromProto(proto) {
    let m = new ListOpportunitiesRequestFilters();
    m = Object.assign(m, proto);
    if (proto.createdDateFilter) {
      m.createdDateFilter = DateRangeFilter.fromProto(proto.createdDateFilter);
    }
    if (proto.expectedCloseDateFilter) {
      m.expectedCloseDateFilter = DateRangeFilter.fromProto(proto.expectedCloseDateFilter);
    }
    if (proto.probabilityRangeFilter) {
      m.probabilityRangeFilter = ProbabilityRangeFilter.fromProto(proto.probabilityRangeFilter);
    }
    if (proto.actualCloseDateFilter) {
      m.actualCloseDateFilter = DateRangeFilter.fromProto(proto.actualCloseDateFilter);
    }
    if (proto.revenuePeriodFilter) {
      m.revenuePeriodFilter = RevenuePeriodFilter.fromProto(proto.revenuePeriodFilter);
    }
    if (proto.assignedDate) {
      m.assignedDate = DateRangeFilter.fromProto(proto.assignedDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.salesPersonIds !== 'undefined') {
      toReturn['salesPersonIds'] = this.salesPersonIds;
    }
    if (typeof this.pipelineStages !== 'undefined') {
      toReturn['pipelineStages'] = this.pipelineStages;
    }
    if (typeof this.createdDateFilter !== 'undefined' && this.createdDateFilter !== null) {
      toReturn['createdDateFilter'] = 'toApiJson' in this.createdDateFilter ? this.createdDateFilter.toApiJson() : this.createdDateFilter;
    }
    if (typeof this.expectedCloseDateFilter !== 'undefined' && this.expectedCloseDateFilter !== null) {
      toReturn['expectedCloseDateFilter'] = 'toApiJson' in this.expectedCloseDateFilter ? this.expectedCloseDateFilter.toApiJson() : this.expectedCloseDateFilter;
    }
    if (typeof this.probabilityRangeFilter !== 'undefined' && this.probabilityRangeFilter !== null) {
      toReturn['probabilityRangeFilter'] = 'toApiJson' in this.probabilityRangeFilter ? this.probabilityRangeFilter.toApiJson() : this.probabilityRangeFilter;
    }
    if (typeof this.packageIds !== 'undefined') {
      toReturn['packageIds'] = this.packageIds;
    }
    if (typeof this.actualCloseDateFilter !== 'undefined' && this.actualCloseDateFilter !== null) {
      toReturn['actualCloseDateFilter'] = 'toApiJson' in this.actualCloseDateFilter ? this.actualCloseDateFilter.toApiJson() : this.actualCloseDateFilter;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    if (typeof this.accountGroupIdsForTag !== 'undefined') {
      toReturn['accountGroupIdsForTag'] = this.accountGroupIdsForTag;
    }
    if (typeof this.lineItemProductIds !== 'undefined') {
      toReturn['lineItemProductIds'] = this.lineItemProductIds;
    }
    if (typeof this.revenuePeriodFilter !== 'undefined' && this.revenuePeriodFilter !== null) {
      toReturn['revenuePeriodFilter'] = 'toApiJson' in this.revenuePeriodFilter ? this.revenuePeriodFilter.toApiJson() : this.revenuePeriodFilter;
    }
    if (typeof this.pipelineIds !== 'undefined') {
      toReturn['pipelineIds'] = this.pipelineIds;
    }
    if (typeof this.assignedDate !== 'undefined' && this.assignedDate !== null) {
      toReturn['assignedDate'] = 'toApiJson' in this.assignedDate ? this.assignedDate.toApiJson() : this.assignedDate;
    }
    if (typeof this.opportunityTypes !== 'undefined') {
      toReturn['opportunityTypes'] = this.opportunityTypes;
    }
    return toReturn;
  }
}
class InitiateOpportunityExportRequest {
  static fromProto(proto) {
    let m = new InitiateOpportunityExportRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListOpportunitiesRequestFilters.fromProto(proto.filters);
    }
    if (proto.sortOption) {
      m.sortOption = ListOpportunitiesRequestSortOption.fromProto(proto.sortOption);
    }
    if (proto.csvFormatOptions) {
      m.csvFormatOptions = CSVFormatOptions.fromProto(proto.csvFormatOptions);
    }
    if (proto.csvExports) {
      m.csvExports = CSVExports.fromProto(proto.csvExports);
    }
    if (proto.clientOrigin) {
      m.clientOrigin = enumStringToValue$5(ClientOrigin, proto.clientOrigin);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.sortOption !== 'undefined' && this.sortOption !== null) {
      toReturn['sortOption'] = 'toApiJson' in this.sortOption ? this.sortOption.toApiJson() : this.sortOption;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.csvFormatOptions !== 'undefined' && this.csvFormatOptions !== null) {
      toReturn['csvFormatOptions'] = 'toApiJson' in this.csvFormatOptions ? this.csvFormatOptions.toApiJson() : this.csvFormatOptions;
    }
    if (typeof this.csvExports !== 'undefined' && this.csvExports !== null) {
      toReturn['csvExports'] = 'toApiJson' in this.csvExports ? this.csvExports.toApiJson() : this.csvExports;
    }
    if (typeof this.clientOrigin !== 'undefined') {
      toReturn['clientOrigin'] = this.clientOrigin;
    }
    return toReturn;
  }
}
class ListOpportunitiesRequest {
  static fromProto(proto) {
    let m = new ListOpportunitiesRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.filters) {
      m.filters = ListOpportunitiesRequestFilters.fromProto(proto.filters);
    }
    if (proto.sortOption) {
      m.sortOption = ListOpportunitiesRequestSortOption.fromProto(proto.sortOption);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.salesPersonIds !== 'undefined') {
      toReturn['salesPersonIds'] = this.salesPersonIds;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.sortOption !== 'undefined' && this.sortOption !== null) {
      toReturn['sortOption'] = 'toApiJson' in this.sortOption ? this.sortOption.toApiJson() : this.sortOption;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class Opportunity {
  static fromProto(proto) {
    let m = new Opportunity();
    m = Object.assign(m, proto);
    if (proto.packages) {
      m.packages = proto.packages.map(Package.fromProto);
    }
    if (proto.expectedCloseDate) {
      m.expectedCloseDate = new Date(proto.expectedCloseDate);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.projectedFirstYearValue) {
      m.projectedFirstYearValue = parseInt(proto.projectedFirstYearValue, 10);
    }
    if (proto.probableFirstYearValue) {
      m.probableFirstYearValue = parseInt(proto.probableFirstYearValue, 10);
    }
    if (proto.closedLostReason) {
      m.closedLostReason = ClosedLostReason.fromProto(proto.closedLostReason);
    }
    if (proto.actualClosedDate) {
      m.actualClosedDate = new Date(proto.actualClosedDate);
    }
    if (proto.lastConnectedDate) {
      m.lastConnectedDate = new Date(proto.lastConnectedDate);
    }
    if (proto.lastActivityDate) {
      m.lastActivityDate = new Date(proto.lastActivityDate);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(Attachment.fromProto);
    }
    if (proto.expectedContractDuration) {
      m.expectedContractDuration = Duration.fromProto(proto.expectedContractDuration);
    }
    if (proto.lineItems) {
      m.lineItems = proto.lineItems.map(LineItem.fromProto);
    }
    if (proto.scoring) {
      m.scoring = Scoring.fromProto(proto.scoring);
    }
    if (proto.forecasting) {
      m.forecasting = Forecasting.fromProto(proto.forecasting);
    }
    if (proto.assignedDate) {
      m.assignedDate = new Date(proto.assignedDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.packages !== 'undefined' && this.packages !== null) {
      toReturn['packages'] = 'toApiJson' in this.packages ? this.packages.toApiJson() : this.packages;
    }
    if (typeof this.expectedCloseDate !== 'undefined' && this.expectedCloseDate !== null) {
      toReturn['expectedCloseDate'] = 'toApiJson' in this.expectedCloseDate ? this.expectedCloseDate.toApiJson() : this.expectedCloseDate;
    }
    if (typeof this.probability !== 'undefined') {
      toReturn['probability'] = this.probability;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.projectedFirstYearValue !== 'undefined') {
      toReturn['projectedFirstYearValue'] = this.projectedFirstYearValue;
    }
    if (typeof this.probableFirstYearValue !== 'undefined') {
      toReturn['probableFirstYearValue'] = this.probableFirstYearValue;
    }
    if (typeof this.pipelineStage !== 'undefined') {
      toReturn['pipelineStage'] = this.pipelineStage;
    }
    if (typeof this.isClosed !== 'undefined') {
      toReturn['isClosed'] = this.isClosed;
    }
    if (typeof this.closedLostReason !== 'undefined' && this.closedLostReason !== null) {
      toReturn['closedLostReason'] = 'toApiJson' in this.closedLostReason ? this.closedLostReason.toApiJson() : this.closedLostReason;
    }
    if (typeof this.actualClosedDate !== 'undefined' && this.actualClosedDate !== null) {
      toReturn['actualClosedDate'] = 'toApiJson' in this.actualClosedDate ? this.actualClosedDate.toApiJson() : this.actualClosedDate;
    }
    if (typeof this.lastConnectedDate !== 'undefined' && this.lastConnectedDate !== null) {
      toReturn['lastConnectedDate'] = 'toApiJson' in this.lastConnectedDate ? this.lastConnectedDate.toApiJson() : this.lastConnectedDate;
    }
    if (typeof this.lastActivityDate !== 'undefined' && this.lastActivityDate !== null) {
      toReturn['lastActivityDate'] = 'toApiJson' in this.lastActivityDate ? this.lastActivityDate.toApiJson() : this.lastActivityDate;
    }
    if (typeof this.reopenedReason !== 'undefined') {
      toReturn['reopenedReason'] = this.reopenedReason;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    if (typeof this.expectedContractDuration !== 'undefined' && this.expectedContractDuration !== null) {
      toReturn['expectedContractDuration'] = 'toApiJson' in this.expectedContractDuration ? this.expectedContractDuration.toApiJson() : this.expectedContractDuration;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    if (typeof this.canReopen !== 'undefined') {
      toReturn['canReopen'] = this.canReopen;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    if (typeof this.scoring !== 'undefined' && this.scoring !== null) {
      toReturn['scoring'] = 'toApiJson' in this.scoring ? this.scoring.toApiJson() : this.scoring;
    }
    if (typeof this.forecasting !== 'undefined' && this.forecasting !== null) {
      toReturn['forecasting'] = 'toApiJson' in this.forecasting ? this.forecasting.toApiJson() : this.forecasting;
    }
    if (typeof this.subscriberUserIds !== 'undefined') {
      toReturn['subscriberUserIds'] = this.subscriberUserIds;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.assignedDate !== 'undefined' && this.assignedDate !== null) {
      toReturn['assignedDate'] = 'toApiJson' in this.assignedDate ? this.assignedDate.toApiJson() : this.assignedDate;
    }
    if (typeof this.opportunityType !== 'undefined') {
      toReturn['opportunityType'] = this.opportunityType;
    }
    return toReturn;
  }
}
class OpportunityCount {
  static fromProto(proto) {
    let m = new OpportunityCount();
    m = Object.assign(m, proto);
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class OpportunityValue {
  static fromProto(proto) {
    let m = new OpportunityValue();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class Package {
  static fromProto(proto) {
    let m = new Package();
    m = Object.assign(m, proto);
    if (proto.currency) {
      m.currency = enumStringToValue$5(Currency, proto.currency);
    }
    if (proto.initialRevenue) {
      m.initialRevenue = Revenue.fromProto(proto.initialRevenue);
    }
    if (proto.currentRevenue) {
      m.currentRevenue = Revenue.fromProto(proto.currentRevenue);
    }
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.initialRevenue !== 'undefined' && this.initialRevenue !== null) {
      toReturn['initialRevenue'] = 'toApiJson' in this.initialRevenue ? this.initialRevenue.toApiJson() : this.initialRevenue;
    }
    if (typeof this.currentRevenue !== 'undefined' && this.currentRevenue !== null) {
      toReturn['currentRevenue'] = 'toApiJson' in this.currentRevenue ? this.currentRevenue.toApiJson() : this.currentRevenue;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    return toReturn;
  }
}
class PipelineClosePoint {
  static fromProto(proto) {
    let m = new PipelineClosePoint();
    m = Object.assign(m, proto);
    if (proto.month) {
      m.month = new Date(proto.month);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.month !== 'undefined' && this.month !== null) {
      toReturn['month'] = 'toApiJson' in this.month ? this.month.toApiJson() : this.month;
    }
    if (typeof this.wonOpportunities !== 'undefined') {
      toReturn['wonOpportunities'] = this.wonOpportunities;
    }
    if (typeof this.lostOpportunities !== 'undefined') {
      toReturn['lostOpportunities'] = this.lostOpportunities;
    }
    if (typeof this.totalOpportunities !== 'undefined') {
      toReturn['totalOpportunities'] = this.totalOpportunities;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    return toReturn;
  }
}
class PipelineCreationPoint {
  static fromProto(proto) {
    let m = new PipelineCreationPoint();
    m = Object.assign(m, proto);
    if (proto.month) {
      m.month = new Date(proto.month);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.month !== 'undefined' && this.month !== null) {
      toReturn['month'] = 'toApiJson' in this.month ? this.month.toApiJson() : this.month;
    }
    if (typeof this.createdOpportunities !== 'undefined') {
      toReturn['createdOpportunities'] = this.createdOpportunities;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    return toReturn;
  }
}
class ProbabilityRangeFilter {
  static fromProto(proto) {
    let m = new ProbabilityRangeFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.minimum !== 'undefined') {
      toReturn['minimum'] = this.minimum;
    }
    if (typeof this.maximum !== 'undefined') {
      toReturn['maximum'] = this.maximum;
    }
    return toReturn;
  }
}
class RevenuePeriodFilter {
  static fromProto(proto) {
    let m = new RevenuePeriodFilter();
    m = Object.assign(m, proto);
    if (proto.revenueDate) {
      m.revenueDate = new Date(proto.revenueDate);
    }
    if (proto.revenuePeriod) {
      m.revenuePeriod = enumStringToValue$5(OpportunityRevenuePeriod, proto.revenuePeriod);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.revenueDate !== 'undefined' && this.revenueDate !== null) {
      toReturn['revenueDate'] = 'toApiJson' in this.revenueDate ? this.revenueDate.toApiJson() : this.revenueDate;
    }
    if (typeof this.revenuePeriod !== 'undefined') {
      toReturn['revenuePeriod'] = this.revenuePeriod;
    }
    return toReturn;
  }
}
class ListOpportunitiesRequestSortOption {
  static fromProto(proto) {
    let m = new ListOpportunitiesRequestSortOption();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue$5(SortDirection, proto.direction);
    }
    if (proto.field) {
      m.field = enumStringToValue$5(ListOpportunitiesRequestSortField, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Pipeline {
  static fromProto(proto) {
    let m = new Pipeline();
    m = Object.assign(m, proto);
    if (proto.stages) {
      m.stages = proto.stages.map(Stage.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.stages !== 'undefined' && this.stages !== null) {
      toReturn['stages'] = 'toApiJson' in this.stages ? this.stages.toApiJson() : this.stages;
    }
    return toReturn;
  }
}
class Stage {
  static fromProto(proto) {
    let m = new Stage();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stageId !== 'undefined') {
      toReturn['stageId'] = this.stageId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.probability !== 'undefined') {
      toReturn['probability'] = this.probability;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Goal {
  static fromProto(proto) {
    let m = new Goal();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$2(GoalType, proto.type);
    }
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.targets) {
      m.targets = proto.targets.map(Target.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.contributorId !== 'undefined') {
      toReturn['contributorId'] = this.contributorId;
    }
    if (typeof this.contributorType !== 'undefined') {
      toReturn['contributorType'] = this.contributorType;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.pipelineIds !== 'undefined') {
      toReturn['pipelineIds'] = this.pipelineIds;
    }
    if (typeof this.interval !== 'undefined') {
      toReturn['interval'] = this.interval;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.targets !== 'undefined' && this.targets !== null) {
      toReturn['targets'] = 'toApiJson' in this.targets ? this.targets.toApiJson() : this.targets;
    }
    if (typeof this.createdBy !== 'undefined') {
      toReturn['createdBy'] = this.createdBy;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class Target {
  static fromProto(proto) {
    let m = new Target();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddAttachmentToOpportunityRequest {
  static fromProto(proto) {
    let m = new AddAttachmentToOpportunityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class AddOpportunityPackagesRequest {
  static fromProto(proto) {
    let m = new AddOpportunityPackagesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.packageIds !== 'undefined') {
      toReturn['packageIds'] = this.packageIds;
    }
    return toReturn;
  }
}
class AddOpportunityPackagesResponse {
  static fromProto(proto) {
    let m = new AddOpportunityPackagesResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class AddPipelineStagesRequestAddPipelineStage {
  static fromProto(proto) {
    let m = new AddPipelineStagesRequestAddPipelineStage();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.probability !== 'undefined') {
      toReturn['probability'] = this.probability;
    }
    return toReturn;
  }
}
class AddPipelineStagesRequest {
  static fromProto(proto) {
    let m = new AddPipelineStagesRequest();
    m = Object.assign(m, proto);
    if (proto.stages) {
      m.stages = proto.stages.map(AddPipelineStagesRequestAddPipelineStage.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    if (typeof this.stages !== 'undefined' && this.stages !== null) {
      toReturn['stages'] = 'toApiJson' in this.stages ? this.stages.toApiJson() : this.stages;
    }
    return toReturn;
  }
}
class AddPipelineStagesResponse {
  static fromProto(proto) {
    let m = new AddPipelineStagesResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class ArchiveGoalRequest {
  static fromProto(proto) {
    let m = new ArchiveGoalRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class CloseAsLostOpportunityRequest {
  static fromProto(proto) {
    let m = new CloseAsLostOpportunityRequest();
    m = Object.assign(m, proto);
    if (proto.reason) {
      m.reason = enumStringToValue(ClosedLostReasonOption, proto.reason);
    }
    if (proto.closeDate) {
      m.closeDate = new Date(proto.closeDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.closeDate !== 'undefined' && this.closeDate !== null) {
      toReturn['closeDate'] = 'toApiJson' in this.closeDate ? this.closeDate.toApiJson() : this.closeDate;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    return toReturn;
  }
}
class CloseAsLostOpportunityResponse {
  static fromProto(proto) {
    let m = new CloseAsLostOpportunityResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class CloseAsWonOpportunityRequest {
  static fromProto(proto) {
    let m = new CloseAsWonOpportunityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    return toReturn;
  }
}
class CloseAsWonOpportunityResponse {
  static fromProto(proto) {
    let m = new CloseAsWonOpportunityResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class CreateGoalRequest {
  static fromProto(proto) {
    let m = new CreateGoalRequest();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.targets) {
      m.targets = proto.targets.map(Target.fromProto);
    }
    if (proto.goalType) {
      m.goalType = enumStringToValue(GoalType, proto.goalType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.contributorId !== 'undefined') {
      toReturn['contributorId'] = this.contributorId;
    }
    if (typeof this.contributorType !== 'undefined') {
      toReturn['contributorType'] = this.contributorType;
    }
    if (typeof this.pipelineIds !== 'undefined') {
      toReturn['pipelineIds'] = this.pipelineIds;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.targets !== 'undefined' && this.targets !== null) {
      toReturn['targets'] = 'toApiJson' in this.targets ? this.targets.toApiJson() : this.targets;
    }
    if (typeof this.goalType !== 'undefined') {
      toReturn['goalType'] = this.goalType;
    }
    return toReturn;
  }
}
class CreateOpportunityRequestCreateOpportunityPackage {
  static fromProto(proto) {
    let m = new CreateOpportunityRequestCreateOpportunityPackage();
    m = Object.assign(m, proto);
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    return toReturn;
  }
}
class CreateOpportunityRequest {
  static fromProto(proto) {
    let m = new CreateOpportunityRequest();
    m = Object.assign(m, proto);
    if (proto.expectedCloseDate) {
      m.expectedCloseDate = new Date(proto.expectedCloseDate);
    }
    if (proto.packages) {
      m.packages = proto.packages.map(CreateOpportunityRequestCreateOpportunityPackage.fromProto);
    }
    if (proto.expectedContractDuration) {
      m.expectedContractDuration = Duration.fromProto(proto.expectedContractDuration);
    }
    if (proto.lineItems) {
      m.lineItems = proto.lineItems.map(LineItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.packageIds !== 'undefined') {
      toReturn['packageIds'] = this.packageIds;
    }
    if (typeof this.expectedCloseDate !== 'undefined' && this.expectedCloseDate !== null) {
      toReturn['expectedCloseDate'] = 'toApiJson' in this.expectedCloseDate ? this.expectedCloseDate.toApiJson() : this.expectedCloseDate;
    }
    if (typeof this.probability !== 'undefined') {
      toReturn['probability'] = this.probability;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.packages !== 'undefined' && this.packages !== null) {
      toReturn['packages'] = 'toApiJson' in this.packages ? this.packages.toApiJson() : this.packages;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.expectedContractDuration !== 'undefined' && this.expectedContractDuration !== null) {
      toReturn['expectedContractDuration'] = 'toApiJson' in this.expectedContractDuration ? this.expectedContractDuration.toApiJson() : this.expectedContractDuration;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    if (typeof this.subscriberUserIds !== 'undefined') {
      toReturn['subscriberUserIds'] = this.subscriberUserIds;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.opportunityType !== 'undefined') {
      toReturn['opportunityType'] = this.opportunityType;
    }
    return toReturn;
  }
}
class CreateOpportunityResponse {
  static fromProto(proto) {
    let m = new CreateOpportunityResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class CreatePipelineRequest {
  static fromProto(proto) {
    let m = new CreatePipelineRequest();
    m = Object.assign(m, proto);
    if (proto.stages) {
      m.stages = proto.stages.map(CreatePipelineRequestCreatePipelineStage.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.stages !== 'undefined' && this.stages !== null) {
      toReturn['stages'] = 'toApiJson' in this.stages ? this.stages.toApiJson() : this.stages;
    }
    return toReturn;
  }
}
class CreatePipelineResponse {
  static fromProto(proto) {
    let m = new CreatePipelineResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    return toReturn;
  }
}
class CreatePipelineRequestCreatePipelineStage {
  static fromProto(proto) {
    let m = new CreatePipelineRequestCreatePipelineStage();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.probability !== 'undefined') {
      toReturn['probability'] = this.probability;
    }
    return toReturn;
  }
}
class DeleteGoalRequest {
  static fromProto(proto) {
    let m = new DeleteGoalRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class DeleteOpportunityRequest {
  static fromProto(proto) {
    let m = new DeleteOpportunityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    return toReturn;
  }
}
class DeletePipelineRequest {
  static fromProto(proto) {
    let m = new DeletePipelineRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    return toReturn;
  }
}
class DeletePipelineResponse {
  static fromProto(proto) {
    let m = new DeletePipelineResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class ListGoalsRequestFilters {
  static fromProto(proto) {
    let m = new ListGoalsRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contributorId !== 'undefined') {
      toReturn['contributorId'] = this.contributorId;
    }
    if (typeof this.contributorType !== 'undefined') {
      toReturn['contributorType'] = this.contributorType;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class GetGoalRequest {
  static fromProto(proto) {
    let m = new GetGoalRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetMEDDICScoresRequest {
  static fromProto(proto) {
    let m = new GetMEDDICScoresRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    return toReturn;
  }
}
class GetMEDDICScoresResponse {
  static fromProto(proto) {
    let m = new GetMEDDICScoresResponse();
    m = Object.assign(m, proto);
    if (proto.scores) {
      m.scores = MEDDICScores.fromProto(proto.scores);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scores !== 'undefined' && this.scores !== null) {
      toReturn['scores'] = 'toApiJson' in this.scores ? this.scores.toApiJson() : this.scores;
    }
    return toReturn;
  }
}
class GetMEDDICSectionsRequest {
  static fromProto(proto) {
    let m = new GetMEDDICSectionsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    return toReturn;
  }
}
class GetMEDDICSectionsResponse {
  static fromProto(proto) {
    let m = new GetMEDDICSectionsResponse();
    m = Object.assign(m, proto);
    if (proto.sections) {
      m.sections = Scoring.fromProto(proto.sections);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sections !== 'undefined' && this.sections !== null) {
      toReturn['sections'] = 'toApiJson' in this.sections ? this.sections.toApiJson() : this.sections;
    }
    return toReturn;
  }
}
class GetOpportunityByIdempotencyKeyRequest {
  static fromProto(proto) {
    let m = new GetOpportunityByIdempotencyKeyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    return toReturn;
  }
}
class GetOpportunityCountByAccountGroupsRequest {
  static fromProto(proto) {
    let m = new GetOpportunityCountByAccountGroupsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    if (typeof this.onlyUnclosed !== 'undefined') {
      toReturn['onlyUnclosed'] = this.onlyUnclosed;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetOpportunityCountByAccountGroupsResponse {
  static fromProto(proto) {
    let m = new GetOpportunityCountByAccountGroupsResponse();
    m = Object.assign(m, proto);
    if (proto.results) {
      m.results = proto.results.map(OpportunityCount.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    return toReturn;
  }
}
class GetOpportunityRequest {
  static fromProto(proto) {
    let m = new GetOpportunityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetOpportunityResponse {
  static fromProto(proto) {
    let m = new GetOpportunityResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class GetOpportunityValueByAccountGroupsRequest {
  static fromProto(proto) {
    let m = new GetOpportunityValueByAccountGroupsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetOpportunityValueByAccountGroupsResponse {
  static fromProto(proto) {
    let m = new GetOpportunityValueByAccountGroupsResponse();
    m = Object.assign(m, proto);
    if (proto.results) {
      m.results = proto.results.map(OpportunityValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    return toReturn;
  }
}
class GetTagsForOpportunitiesRequest {
  static fromProto(proto) {
    let m = new GetTagsForOpportunitiesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetTagsForOpportunitiesResponse {
  static fromProto(proto) {
    let m = new GetTagsForOpportunitiesResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
class GoalResponse {
  static fromProto(proto) {
    let m = new GoalResponse();
    m = Object.assign(m, proto);
    if (proto.goal) {
      m.goal = Goal.fromProto(proto.goal);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goal !== 'undefined' && this.goal !== null) {
      toReturn['goal'] = 'toApiJson' in this.goal ? this.goal.toApiJson() : this.goal;
    }
    return toReturn;
  }
}
class InitiateOpportunityExportResponse {
  static fromProto(proto) {
    let m = new InitiateOpportunityExportResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.exportId !== 'undefined') {
      toReturn['exportId'] = this.exportId;
    }
    return toReturn;
  }
}
class ListGoalsRequest {
  static fromProto(proto) {
    let m = new ListGoalsRequest();
    m = Object.assign(m, proto);
    if (proto.pageOptions) {
      m.pageOptions = PagedRequestOptions.fromProto(proto.pageOptions);
    }
    if (proto.filters) {
      m.filters = ListGoalsRequestFilters.fromProto(proto.filters);
    }
    if (proto.sortOption) {
      m.sortOption = ListGoalsRequestSortOption.fromProto(proto.sortOption);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageOptions !== 'undefined' && this.pageOptions !== null) {
      toReturn['pageOptions'] = 'toApiJson' in this.pageOptions ? this.pageOptions.toApiJson() : this.pageOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.sortOption !== 'undefined' && this.sortOption !== null) {
      toReturn['sortOption'] = 'toApiJson' in this.sortOption ? this.sortOption.toApiJson() : this.sortOption;
    }
    return toReturn;
  }
}
class ListGoalsResponse {
  static fromProto(proto) {
    let m = new ListGoalsResponse();
    m = Object.assign(m, proto);
    if (proto.goals) {
      m.goals = proto.goals.map(Goal.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goals !== 'undefined' && this.goals !== null) {
      toReturn['goals'] = 'toApiJson' in this.goals ? this.goals.toApiJson() : this.goals;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListOpportunitiesResponse {
  static fromProto(proto) {
    let m = new ListOpportunitiesResponse();
    m = Object.assign(m, proto);
    if (proto.results) {
      m.results = proto.results.map(Opportunity.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    if (proto.totalProjectedFirstYearValue) {
      m.totalProjectedFirstYearValue = parseInt(proto.totalProjectedFirstYearValue, 10);
    }
    if (proto.totalRevenueForRevenuePeriod) {
      m.totalRevenueForRevenuePeriod = parseInt(proto.totalRevenueForRevenuePeriod, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    if (typeof this.totalProjectedFirstYearValue !== 'undefined') {
      toReturn['totalProjectedFirstYearValue'] = this.totalProjectedFirstYearValue;
    }
    if (typeof this.totalRevenueForRevenuePeriod !== 'undefined') {
      toReturn['totalRevenueForRevenuePeriod'] = this.totalRevenueForRevenuePeriod;
    }
    return toReturn;
  }
}
class ListPipelinesRequest {
  static fromProto(proto) {
    let m = new ListPipelinesRequest();
    m = Object.assign(m, proto);
    if (proto.pageOptions) {
      m.pageOptions = PagedRequestOptions.fromProto(proto.pageOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageOptions !== 'undefined' && this.pageOptions !== null) {
      toReturn['pageOptions'] = 'toApiJson' in this.pageOptions ? this.pageOptions.toApiJson() : this.pageOptions;
    }
    return toReturn;
  }
}
class ListPipelinesResponse {
  static fromProto(proto) {
    let m = new ListPipelinesResponse();
    m = Object.assign(m, proto);
    if (proto.results) {
      m.results = proto.results.map(Pipeline.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class RemoveOpportunityPackagesRequest {
  static fromProto(proto) {
    let m = new RemoveOpportunityPackagesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.packageIds !== 'undefined') {
      toReturn['packageIds'] = this.packageIds;
    }
    return toReturn;
  }
}
class RemoveOpportunityPackagesResponse {
  static fromProto(proto) {
    let m = new RemoveOpportunityPackagesResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class RemovePipelineStagesRequest {
  static fromProto(proto) {
    let m = new RemovePipelineStagesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    if (typeof this.stageIds !== 'undefined') {
      toReturn['stageIds'] = this.stageIds;
    }
    return toReturn;
  }
}
class RemovePipelineStagesResponse {
  static fromProto(proto) {
    let m = new RemovePipelineStagesResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class ReopenClosedOpportunityRequest {
  static fromProto(proto) {
    let m = new ReopenClosedOpportunityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    return toReturn;
  }
}
class RestoreDeletedPipelineRequest {
  static fromProto(proto) {
    let m = new RestoreDeletedPipelineRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    return toReturn;
  }
}
class RestoreDeletedPipelineResponse {
  static fromProto(proto) {
    let m = new RestoreDeletedPipelineResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class SalespersonStatsRequest {
  static fromProto(proto) {
    let m = new SalespersonStatsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    return toReturn;
  }
}
class SalespersonStatsResponse {
  static fromProto(proto) {
    let m = new SalespersonStatsResponse();
    m = Object.assign(m, proto);
    if (proto.pipelineCloseRates) {
      m.pipelineCloseRates = proto.pipelineCloseRates.map(PipelineClosePoint.fromProto);
    }
    if (proto.pipelineCreationRates) {
      m.pipelineCreationRates = proto.pipelineCreationRates.map(PipelineCreationPoint.fromProto);
    }
    if (proto.currentOpporunities) {
      m.currentOpporunities = proto.currentOpporunities.map(CurrentOpportunityPoint.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pipelineCloseRates !== 'undefined' && this.pipelineCloseRates !== null) {
      toReturn['pipelineCloseRates'] = 'toApiJson' in this.pipelineCloseRates ? this.pipelineCloseRates.toApiJson() : this.pipelineCloseRates;
    }
    if (typeof this.pipelineCreationRates !== 'undefined' && this.pipelineCreationRates !== null) {
      toReturn['pipelineCreationRates'] = 'toApiJson' in this.pipelineCreationRates ? this.pipelineCreationRates.toApiJson() : this.pipelineCreationRates;
    }
    if (typeof this.currentOpporunities !== 'undefined' && this.currentOpporunities !== null) {
      toReturn['currentOpporunities'] = 'toApiJson' in this.currentOpporunities ? this.currentOpporunities.toApiJson() : this.currentOpporunities;
    }
    return toReturn;
  }
}
class SetPipelineStagesRequest {
  static fromProto(proto) {
    let m = new SetPipelineStagesRequest();
    m = Object.assign(m, proto);
    if (proto.stages) {
      m.stages = proto.stages.map(Stage.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    if (typeof this.stages !== 'undefined' && this.stages !== null) {
      toReturn['stages'] = 'toApiJson' in this.stages ? this.stages.toApiJson() : this.stages;
    }
    return toReturn;
  }
}
class SetPipelineStagesResponse {
  static fromProto(proto) {
    let m = new SetPipelineStagesResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class ListGoalsRequestSortOption {
  static fromProto(proto) {
    let m = new ListGoalsRequestSortOption();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue(ListGoalsRequestSortDirection, proto.direction);
    }
    if (proto.field) {
      m.field = enumStringToValue(ListGoalsRequestSortField, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}
class UpdateClosedDateRequest {
  static fromProto(proto) {
    let m = new UpdateClosedDateRequest();
    m = Object.assign(m, proto);
    if (proto.closedDate) {
      m.closedDate = new Date(proto.closedDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.closedDate !== 'undefined' && this.closedDate !== null) {
      toReturn['closedDate'] = 'toApiJson' in this.closedDate ? this.closedDate.toApiJson() : this.closedDate;
    }
    return toReturn;
  }
}
class UpdateGoalRequest {
  static fromProto(proto) {
    let m = new UpdateGoalRequest();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.targets) {
      m.targets = proto.targets.map(Target.fromProto);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.contributorId !== 'undefined') {
      toReturn['contributorId'] = this.contributorId;
    }
    if (typeof this.contributorType !== 'undefined') {
      toReturn['contributorType'] = this.contributorType;
    }
    if (typeof this.pipelineIds !== 'undefined') {
      toReturn['pipelineIds'] = this.pipelineIds;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.targets !== 'undefined' && this.targets !== null) {
      toReturn['targets'] = 'toApiJson' in this.targets ? this.targets.toApiJson() : this.targets;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateLastActivityDateRequest {
  static fromProto(proto) {
    let m = new UpdateLastActivityDateRequest();
    m = Object.assign(m, proto);
    if (proto.lastActivityDate) {
      m.lastActivityDate = new Date(proto.lastActivityDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.lastActivityDate !== 'undefined' && this.lastActivityDate !== null) {
      toReturn['lastActivityDate'] = 'toApiJson' in this.lastActivityDate ? this.lastActivityDate.toApiJson() : this.lastActivityDate;
    }
    if (typeof this.connected !== 'undefined') {
      toReturn['connected'] = this.connected;
    }
    return toReturn;
  }
}
class UpdateLastActivityDateResponse {
  static fromProto(proto) {
    let m = new UpdateLastActivityDateResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdateLastConnectedDateRequest {
  static fromProto(proto) {
    let m = new UpdateLastConnectedDateRequest();
    m = Object.assign(m, proto);
    if (proto.lastConnectedDate) {
      m.lastConnectedDate = new Date(proto.lastConnectedDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.lastConnectedDate !== 'undefined' && this.lastConnectedDate !== null) {
      toReturn['lastConnectedDate'] = 'toApiJson' in this.lastConnectedDate ? this.lastConnectedDate.toApiJson() : this.lastConnectedDate;
    }
    return toReturn;
  }
}
class UpdateLastConnectedDateResponse {
  static fromProto(proto) {
    let m = new UpdateLastConnectedDateResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdateLineItemsRequest {
  static fromProto(proto) {
    let m = new UpdateLineItemsRequest();
    m = Object.assign(m, proto);
    if (proto.lineItems) {
      m.lineItems = proto.lineItems.map(LineItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    return toReturn;
  }
}
class UpdateLineItemsResponse {
  static fromProto(proto) {
    let m = new UpdateLineItemsResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdateMEDDICNotesRequest {
  static fromProto(proto) {
    let m = new UpdateMEDDICNotesRequest();
    m = Object.assign(m, proto);
    if (proto.sectionName) {
      m.sectionName = enumStringToValue(MEDDICSection, proto.sectionName);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sectionName !== 'undefined') {
      toReturn['sectionName'] = this.sectionName;
    }
    if (typeof this.sectionNotes !== 'undefined') {
      toReturn['sectionNotes'] = this.sectionNotes;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    return toReturn;
  }
}
class UpdateMEDDICScoringRequest {
  static fromProto(proto) {
    let m = new UpdateMEDDICScoringRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.metricScoreValue !== 'undefined') {
      toReturn['metricScoreValue'] = this.metricScoreValue;
    }
    if (typeof this.economicBuyerScoreValue !== 'undefined') {
      toReturn['economicBuyerScoreValue'] = this.economicBuyerScoreValue;
    }
    if (typeof this.decisionCriteriaScoreValue !== 'undefined') {
      toReturn['decisionCriteriaScoreValue'] = this.decisionCriteriaScoreValue;
    }
    if (typeof this.decisionProcessScoreValue !== 'undefined') {
      toReturn['decisionProcessScoreValue'] = this.decisionProcessScoreValue;
    }
    if (typeof this.identifyPainScoreValue !== 'undefined') {
      toReturn['identifyPainScoreValue'] = this.identifyPainScoreValue;
    }
    if (typeof this.championScoreValue !== 'undefined') {
      toReturn['championScoreValue'] = this.championScoreValue;
    }
    if (typeof this.competitionScoreValue !== 'undefined') {
      toReturn['competitionScoreValue'] = this.competitionScoreValue;
    }
    if (typeof this.paperProcessScoreValue !== 'undefined') {
      toReturn['paperProcessScoreValue'] = this.paperProcessScoreValue;
    }
    return toReturn;
  }
}
class UpdateOpportunityDurationRequest {
  static fromProto(proto) {
    let m = new UpdateOpportunityDurationRequest();
    m = Object.assign(m, proto);
    if (proto.expectedContractDuration) {
      m.expectedContractDuration = Duration.fromProto(proto.expectedContractDuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.expectedContractDuration !== 'undefined' && this.expectedContractDuration !== null) {
      toReturn['expectedContractDuration'] = 'toApiJson' in this.expectedContractDuration ? this.expectedContractDuration.toApiJson() : this.expectedContractDuration;
    }
    return toReturn;
  }
}
class UpdateOpportunityDurationResponse {
  static fromProto(proto) {
    let m = new UpdateOpportunityDurationResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdateOpportunityExpectedCloseDateRequest {
  static fromProto(proto) {
    let m = new UpdateOpportunityExpectedCloseDateRequest();
    m = Object.assign(m, proto);
    if (proto.expectedCloseDate) {
      m.expectedCloseDate = new Date(proto.expectedCloseDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.expectedCloseDate !== 'undefined' && this.expectedCloseDate !== null) {
      toReturn['expectedCloseDate'] = 'toApiJson' in this.expectedCloseDate ? this.expectedCloseDate.toApiJson() : this.expectedCloseDate;
    }
    if (typeof this.createSalesActivity !== 'undefined') {
      toReturn['createSalesActivity'] = this.createSalesActivity;
    }
    return toReturn;
  }
}
class UpdateOpportunityExpectedCloseDateResponse {
  static fromProto(proto) {
    let m = new UpdateOpportunityExpectedCloseDateResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdateOpportunityMarketRequest {
  static fromProto(proto) {
    let m = new UpdateOpportunityMarketRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class UpdateOpportunityMarketResponse {
  static fromProto(proto) {
    let m = new UpdateOpportunityMarketResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdateOpportunityNameRequest {
  static fromProto(proto) {
    let m = new UpdateOpportunityNameRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class UpdateOpportunityNameResponse {
  static fromProto(proto) {
    let m = new UpdateOpportunityNameResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdateOpportunityNotesRequest {
  static fromProto(proto) {
    let m = new UpdateOpportunityNotesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    return toReturn;
  }
}
class UpdateOpportunityNotesResponse {
  static fromProto(proto) {
    let m = new UpdateOpportunityNotesResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdateOpportunityPackageRequest {
  static fromProto(proto) {
    let m = new UpdateOpportunityPackageRequest();
    m = Object.assign(m, proto);
    if (proto.currentRevenue) {
      m.currentRevenue = Revenue.fromProto(proto.currentRevenue);
    }
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.currentRevenue !== 'undefined' && this.currentRevenue !== null) {
      toReturn['currentRevenue'] = 'toApiJson' in this.currentRevenue ? this.currentRevenue.toApiJson() : this.currentRevenue;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    return toReturn;
  }
}
class UpdateOpportunityPackageResponse {
  static fromProto(proto) {
    let m = new UpdateOpportunityPackageResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdateOpportunityPackageRevenueRequest {
  static fromProto(proto) {
    let m = new UpdateOpportunityPackageRevenueRequest();
    m = Object.assign(m, proto);
    if (proto.revenue) {
      m.revenue = Revenue.fromProto(proto.revenue);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.revenue !== 'undefined' && this.revenue !== null) {
      toReturn['revenue'] = 'toApiJson' in this.revenue ? this.revenue.toApiJson() : this.revenue;
    }
    return toReturn;
  }
}
class UpdateOpportunityPackageRevenueResponse {
  static fromProto(proto) {
    let m = new UpdateOpportunityPackageRevenueResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdateOpportunityPipelineAndProbabilityRequest {
  static fromProto(proto) {
    let m = new UpdateOpportunityPipelineAndProbabilityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    if (typeof this.probability !== 'undefined') {
      toReturn['probability'] = this.probability;
    }
    return toReturn;
  }
}
class UpdateOpportunityPipelineRequest {
  static fromProto(proto) {
    let m = new UpdateOpportunityPipelineRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    return toReturn;
  }
}
class UpdateOpportunityPipelineResponse {
  static fromProto(proto) {
    let m = new UpdateOpportunityPipelineResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class UpdateOpportunityProbabilityRequest {
  static fromProto(proto) {
    let m = new UpdateOpportunityProbabilityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.probability !== 'undefined') {
      toReturn['probability'] = this.probability;
    }
    return toReturn;
  }
}
class UpdateOpportunityProbabilityResponse {
  static fromProto(proto) {
    let m = new UpdateOpportunityProbabilityResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdateOpportunitySalespersonRequest {
  static fromProto(proto) {
    let m = new UpdateOpportunitySalespersonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    if (typeof this.createSalesActivity !== 'undefined') {
      toReturn['createSalesActivity'] = this.createSalesActivity;
    }
    return toReturn;
  }
}
class UpdateOpportunitySalespersonResponse {
  static fromProto(proto) {
    let m = new UpdateOpportunitySalespersonResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdateOpportunityTagsRequest {
  static fromProto(proto) {
    let m = new UpdateOpportunityTagsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
class UpdateOpportunityTagsResponse {
  static fromProto(proto) {
    let m = new UpdateOpportunityTagsResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdateOpportunityTypeRequest {
  static fromProto(proto) {
    let m = new UpdateOpportunityTypeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.opportunityType !== 'undefined') {
      toReturn['opportunityType'] = this.opportunityType;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    return toReturn;
  }
}
class UpdateOpportunityTypeResponse {
  static fromProto(proto) {
    let m = new UpdateOpportunityTypeResponse();
    m = Object.assign(m, proto);
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    return toReturn;
  }
}
class UpdatePipelineNameRequest {
  static fromProto(proto) {
    let m = new UpdatePipelineNameRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class UpdatePipelineNameResponse {
  static fromProto(proto) {
    let m = new UpdatePipelineNameResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class UpdatePipelineStageNameRequest {
  static fromProto(proto) {
    let m = new UpdatePipelineStageNameRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    if (typeof this.stageId !== 'undefined') {
      toReturn['stageId'] = this.stageId;
    }
    if (typeof this.stageName !== 'undefined') {
      toReturn['stageName'] = this.stageName;
    }
    return toReturn;
  }
}
class UpdatePipelineStageNameResponse {
  static fromProto(proto) {
    let m = new UpdatePipelineStageNameResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class UpdatePipelineStageProbabilityRequest {
  static fromProto(proto) {
    let m = new UpdatePipelineStageProbabilityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    if (typeof this.stageId !== 'undefined') {
      toReturn['stageId'] = this.stageId;
    }
    if (typeof this.probability !== 'undefined') {
      toReturn['probability'] = this.probability;
    }
    return toReturn;
  }
}
class UpdatePipelineStageProbabilityResponse {
  static fromProto(proto) {
    let m = new UpdatePipelineStageProbabilityResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class UpdateSubscriberUserIDsRequest {
  static fromProto(proto) {
    let m = new UpdateSubscriberUserIDsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.editSalesPersonId !== 'undefined') {
      toReturn['editSalesPersonId'] = this.editSalesPersonId;
    }
    if (typeof this.subscriberUserIds !== 'undefined') {
      toReturn['subscriberUserIds'] = this.subscriberUserIds;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'sales-opportunities.vendasta-local.com',
  'test': '',
  'demo': 'sales-opportunities-demo.apigateway.co',
  'prod': 'sales-opportunities-prod.apigateway.co',
  'production': 'sales-opportunities-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let GoalsApiService = /*#__PURE__*/(() => {
  class GoalsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateGoalRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.Goals/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => GoalResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateGoalRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.Goals/Update", request.toApiJson(), this.apiOptions()).pipe(map(resp => GoalResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new GetGoalRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.Goals/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GoalResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListGoalsRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.Goals/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListGoalsResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteGoalRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.Goals/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    archive(r) {
      const request = r.toApiJson ? r : new ArchiveGoalRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.Goals/Archive", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  GoalsApiService.ɵfac = function GoalsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GoalsApiService)();
  };
  GoalsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GoalsApiService,
    factory: GoalsApiService.ɵfac,
    providedIn: 'root'
  });
  return GoalsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let OpportunityScoringApiService = /*#__PURE__*/(() => {
  class OpportunityScoringApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMeddicScores(r) {
      const request = r.toApiJson ? r : new GetMEDDICScoresRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.OpportunityScoring/GetMEDDICScores", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMEDDICScoresResponse.fromProto(resp)));
    }
    updateMeddicScoringForOpportunity(r) {
      const request = r.toApiJson ? r : new UpdateMEDDICScoringRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.OpportunityScoring/UpdateMEDDICScoringForOpportunity", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateMeddicNotesForOpportunity(r) {
      const request = r.toApiJson ? r : new UpdateMEDDICNotesRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.OpportunityScoring/UpdateMEDDICNotesForOpportunity", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMeddicSections(r) {
      const request = r.toApiJson ? r : new GetMEDDICSectionsRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.OpportunityScoring/GetMEDDICSections", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMEDDICSectionsResponse.fromProto(resp)));
    }
  }
  OpportunityScoringApiService.ɵfac = function OpportunityScoringApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || OpportunityScoringApiService)();
  };
  OpportunityScoringApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: OpportunityScoringApiService,
    factory: OpportunityScoringApiService.ɵfac,
    providedIn: 'root'
  });
  return OpportunityScoringApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SalesOpportunitiesApiService = /*#__PURE__*/(() => {
  class SalesOpportunitiesApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createOpportunity(r) {
      const request = r.toApiJson ? r : new CreateOpportunityRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/CreateOpportunity", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateOpportunityResponse.fromProto(resp)));
    }
    getOpportunity(r) {
      const request = r.toApiJson ? r : new GetOpportunityRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/GetOpportunity", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOpportunityResponse.fromProto(resp)));
    }
    getOpportunityByIdempotencyKey(r) {
      const request = r.toApiJson ? r : new GetOpportunityByIdempotencyKeyRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/GetOpportunityByIdempotencyKey", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOpportunityResponse.fromProto(resp)));
    }
    listOpportunities(r) {
      const request = r.toApiJson ? r : new ListOpportunitiesRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/ListOpportunities", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListOpportunitiesResponse.fromProto(resp)));
    }
    getOpportunityCountByAccountGroups(r) {
      const request = r.toApiJson ? r : new GetOpportunityCountByAccountGroupsRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/GetOpportunityCountByAccountGroups", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOpportunityCountByAccountGroupsResponse.fromProto(resp)));
    }
    updateOpportunityName(r) {
      const request = r.toApiJson ? r : new UpdateOpportunityNameRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateOpportunityName", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateOpportunityNameResponse.fromProto(resp)));
    }
    updateOpportunityProbability(r) {
      const request = r.toApiJson ? r : new UpdateOpportunityProbabilityRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateOpportunityProbability", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateOpportunityProbabilityResponse.fromProto(resp)));
    }
    updateOpportunityType(r) {
      const request = r.toApiJson ? r : new UpdateOpportunityTypeRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateOpportunityType", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateOpportunityTypeResponse.fromProto(resp)));
    }
    updateOpportunitySalesperson(r) {
      const request = r.toApiJson ? r : new UpdateOpportunitySalespersonRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateOpportunitySalesperson", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateOpportunitySalespersonResponse.fromProto(resp)));
    }
    updateOpportunityExpectedCloseDate(r) {
      const request = r.toApiJson ? r : new UpdateOpportunityExpectedCloseDateRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateOpportunityExpectedCloseDate", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateOpportunityExpectedCloseDateResponse.fromProto(resp)));
    }
    updateOpportunityNotes(r) {
      const request = r.toApiJson ? r : new UpdateOpportunityNotesRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateOpportunityNotes", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateOpportunityNotesResponse.fromProto(resp)));
    }
    addOpportunityPackages(r) {
      const request = r.toApiJson ? r : new AddOpportunityPackagesRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/AddOpportunityPackages", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddOpportunityPackagesResponse.fromProto(resp)));
    }
    removeOpportunityPackages(r) {
      const request = r.toApiJson ? r : new RemoveOpportunityPackagesRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/RemoveOpportunityPackages", request.toApiJson(), this.apiOptions()).pipe(map(resp => RemoveOpportunityPackagesResponse.fromProto(resp)));
    }
    updateOpportunityPackageRevenue(r) {
      const request = r.toApiJson ? r : new UpdateOpportunityPackageRevenueRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateOpportunityPackageRevenue", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateOpportunityPackageRevenueResponse.fromProto(resp)));
    }
    updateOpportunityPackage(r) {
      const request = r.toApiJson ? r : new UpdateOpportunityPackageRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateOpportunityPackage", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateOpportunityPackageResponse.fromProto(resp)));
    }
    closeAsWonOpportunity(r) {
      const request = r.toApiJson ? r : new CloseAsWonOpportunityRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/CloseAsWonOpportunity", request.toApiJson(), this.apiOptions()).pipe(map(resp => CloseAsWonOpportunityResponse.fromProto(resp)));
    }
    closeAsLostOpportunity(r) {
      const request = r.toApiJson ? r : new CloseAsLostOpportunityRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/CloseAsLostOpportunity", request.toApiJson(), this.apiOptions()).pipe(map(resp => CloseAsLostOpportunityResponse.fromProto(resp)));
    }
    updateLastConnectedDate(r) {
      const request = r.toApiJson ? r : new UpdateLastConnectedDateRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateLastConnectedDate", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateLastConnectedDateResponse.fromProto(resp)));
    }
    updateLastActivityDate(r) {
      const request = r.toApiJson ? r : new UpdateLastActivityDateRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateLastActivityDate", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateLastActivityDateResponse.fromProto(resp)));
    }
    deleteOpportunity(r) {
      const request = r.toApiJson ? r : new DeleteOpportunityRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/DeleteOpportunity", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    reopenClosedOpportunity(r) {
      const request = r.toApiJson ? r : new ReopenClosedOpportunityRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/ReopenClosedOpportunity", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateOpportunityMarket(r) {
      const request = r.toApiJson ? r : new UpdateOpportunityMarketRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateOpportunityMarket", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateOpportunityMarketResponse.fromProto(resp)));
    }
    getSalespersonStats(r) {
      const request = r.toApiJson ? r : new SalespersonStatsRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/GetSalespersonStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => SalespersonStatsResponse.fromProto(resp)));
    }
    updateOpportunityTags(r) {
      const request = r.toApiJson ? r : new UpdateOpportunityTagsRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateOpportunityTags", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateOpportunityTagsResponse.fromProto(resp)));
    }
    getTagsForOpportunities(r) {
      const request = r.toApiJson ? r : new GetTagsForOpportunitiesRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/GetTagsForOpportunities", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTagsForOpportunitiesResponse.fromProto(resp)));
    }
    updateOpportunityDuration(r) {
      const request = r.toApiJson ? r : new UpdateOpportunityDurationRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateOpportunityDuration", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateOpportunityDurationResponse.fromProto(resp)));
    }
    updateOpportunityPipeline(r) {
      const request = r.toApiJson ? r : new UpdateOpportunityPipelineRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateOpportunityPipeline", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addAttachmentToOpportunity(r) {
      const request = r.toApiJson ? r : new AddAttachmentToOpportunityRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/AddAttachmentToOpportunity", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateClosedDateForOpportunity(r) {
      const request = r.toApiJson ? r : new UpdateClosedDateRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateClosedDateForOpportunity", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateLineItemsForOpportunity(r) {
      const request = r.toApiJson ? r : new UpdateLineItemsRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateLineItemsForOpportunity", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateLineItemsResponse.fromProto(resp)));
    }
    updateSubscriberUserIDsForOpportunity(r) {
      const request = r.toApiJson ? r : new UpdateSubscriberUserIDsRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateSubscriberUserIDsForOpportunity", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getOpportunityValueByAccountGroups(r) {
      const request = r.toApiJson ? r : new GetOpportunityValueByAccountGroupsRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/GetOpportunityValueByAccountGroups", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOpportunityValueByAccountGroupsResponse.fromProto(resp)));
    }
    initiateOpportunityExport(r) {
      const request = r.toApiJson ? r : new InitiateOpportunityExportRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/InitiateOpportunityExport", request.toApiJson(), this.apiOptions()).pipe(map(resp => InitiateOpportunityExportResponse.fromProto(resp)));
    }
    updateOpportunityPipelineAndProbability(r) {
      const request = r.toApiJson ? r : new UpdateOpportunityPipelineAndProbabilityRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesOpportunities/UpdateOpportunityPipelineAndProbability", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SalesOpportunitiesApiService.ɵfac = function SalesOpportunitiesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalesOpportunitiesApiService)();
  };
  SalesOpportunitiesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesOpportunitiesApiService,
    factory: SalesOpportunitiesApiService.ɵfac,
    providedIn: 'root'
  });
  return SalesOpportunitiesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SalesPipelinesApiService = /*#__PURE__*/(() => {
  class SalesPipelinesApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createPipeline(r) {
      const request = r.toApiJson ? r : new CreatePipelineRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesPipelines/CreatePipeline", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreatePipelineResponse.fromProto(resp)));
    }
    listPipelines(r) {
      const request = r.toApiJson ? r : new ListPipelinesRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesPipelines/ListPipelines", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPipelinesResponse.fromProto(resp)));
    }
    updatePipelineName(r) {
      const request = r.toApiJson ? r : new UpdatePipelineNameRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesPipelines/UpdatePipelineName", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdatePipelineNameResponse.fromProto(resp)));
    }
    updatePipelineStageName(r) {
      const request = r.toApiJson ? r : new UpdatePipelineStageNameRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesPipelines/UpdatePipelineStageName", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdatePipelineStageNameResponse.fromProto(resp)));
    }
    updatePipelineStageProbability(r) {
      const request = r.toApiJson ? r : new UpdatePipelineStageProbabilityRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesPipelines/UpdatePipelineStageProbability", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdatePipelineStageProbabilityResponse.fromProto(resp)));
    }
    setPipelineStages(r) {
      const request = r.toApiJson ? r : new SetPipelineStagesRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesPipelines/SetPipelineStages", request.toApiJson(), this.apiOptions()).pipe(map(resp => SetPipelineStagesResponse.fromProto(resp)));
    }
    addPipelineStages(r) {
      const request = r.toApiJson ? r : new AddPipelineStagesRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesPipelines/AddPipelineStages", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddPipelineStagesResponse.fromProto(resp)));
    }
    removePipelineStages(r) {
      const request = r.toApiJson ? r : new RemovePipelineStagesRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesPipelines/RemovePipelineStages", request.toApiJson(), this.apiOptions()).pipe(map(resp => RemovePipelineStagesResponse.fromProto(resp)));
    }
    deletePipeline(r) {
      const request = r.toApiJson ? r : new DeletePipelineRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesPipelines/DeletePipeline", request.toApiJson(), this.apiOptions()).pipe(map(resp => DeletePipelineResponse.fromProto(resp)));
    }
  }
  SalesPipelinesApiService.ɵfac = function SalesPipelinesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalesPipelinesApiService)();
  };
  SalesPipelinesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesPipelinesApiService,
    factory: SalesPipelinesApiService.ɵfac,
    providedIn: 'root'
  });
  return SalesPipelinesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SalesPipelinesAdminApiService = /*#__PURE__*/(() => {
  class SalesPipelinesAdminApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    restoreDeletedPipeline(r) {
      const request = r.toApiJson ? r : new RestoreDeletedPipelineRequest(r);
      return this.http.post(this._host + "/salesopportunities.v1.SalesPipelinesAdmin/RestoreDeletedPipeline", request.toApiJson(), this.apiOptions()).pipe(map(resp => RestoreDeletedPipelineResponse.fromProto(resp)));
    }
  }
  SalesPipelinesAdminApiService.ɵfac = function SalesPipelinesAdminApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalesPipelinesAdminApiService)();
  };
  SalesPipelinesAdminApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesPipelinesAdminApiService,
    factory: SalesPipelinesAdminApiService.ɵfac,
    providedIn: 'root'
  });
  return SalesPipelinesAdminApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

const DEFAULT_PIPELINE_ID = 'DEFAULT';
let SalesOpportunitiesService = /*#__PURE__*/(() => {
  class SalesOpportunitiesService {
    constructor(_api) {
      this._api = _api;
    }
    updateOpportunityExpectedCloseDate(accountGroupId, opportunityId, editSalesPersonId, expectedCloseDate, createSalesActivity) {
      const req = {
        accountGroupId: accountGroupId,
        opportunityId: opportunityId,
        editSalesPersonId: editSalesPersonId,
        expectedCloseDate: expectedCloseDate,
        createSalesActivity: createSalesActivity ?? false
      };
      return this._api.updateOpportunityExpectedCloseDate(req).pipe(map(resp => resp.opportunity));
    }
    updateOpportunitySalesperson(accountGroupId, opportunityId, editSalesPersonId, salesPersonId, createSalesActivity) {
      const req = {
        accountGroupId: accountGroupId,
        opportunityId: opportunityId,
        editSalesPersonId: editSalesPersonId,
        salesPersonId: salesPersonId,
        createSalesActivity: createSalesActivity ?? false
      };
      return this._api.updateOpportunitySalesperson(req).pipe(map(resp => resp.opportunity));
    }
    addAttachment(opportunityId, accountGroupId, name, url) {
      return this._api.addAttachmentToOpportunity({
        opportunityId: opportunityId,
        accountGroupId: accountGroupId,
        name: name,
        url: url
      });
    }
    create(accountGroupId, salesPersonId, marketId, partnerId, expectedCloseDate, probability, pipelineId, name, packages, notes, tags, expectedContractDuration, lineItems, subscriberUserIds, opportunityType) {
      return this._api.createOpportunity(new CreateOpportunityRequest({
        accountGroupId: accountGroupId,
        salesPersonId: salesPersonId,
        marketId: marketId,
        partnerId: partnerId,
        packages: packages,
        expectedCloseDate: expectedCloseDate,
        probability: probability,
        name: name,
        notes: notes,
        tags: tags,
        expectedContractDuration: expectedContractDuration,
        pipelineId: pipelineId,
        lineItems: lineItems,
        subscriberUserIds: subscriberUserIds,
        opportunityType: opportunityType
      })).pipe(map(resp => resp.opportunity));
    }
    get(opportunityId, accountGroupId) {
      return this._api.getOpportunity({
        opportunityId: opportunityId,
        accountGroupId: accountGroupId
      }).pipe(map(resp => resp.opportunity));
    }
    getTags(partnerId, marketId) {
      return this._api.getTagsForOpportunities({
        partnerId,
        marketId
      }).pipe(map(resp => resp.tags || []));
    }
    updateTags(opportunityID, accountGroupID, editSalespersonID, tags) {
      return this._api.updateOpportunityTags({
        opportunityId: opportunityID,
        accountGroupId: accountGroupID,
        editSalesPersonId: editSalespersonID,
        tags: tags
      }).pipe(map(resp => resp.opportunity));
    }
    updateOpportunityNotes(opportunityId, accountGroupId, editSalesPersonId, notes) {
      return this._api.updateOpportunityNotes({
        opportunityId: opportunityId,
        accountGroupId: accountGroupId,
        editSalesPersonId: editSalesPersonId,
        notes: notes
      }).pipe(map(resp => resp.opportunity));
    }
    getOpportunityCountByAccountGroups(accountGroupIds, onlyOpen, partnerId, marketId) {
      return this._api.getOpportunityCountByAccountGroups({
        accountGroupIds: accountGroupIds,
        onlyUnclosed: onlyOpen,
        partnerId: partnerId,
        marketId: marketId
      }).pipe(map(resp => resp.results));
    }
    getOpportunityValueByAccountGroups(accountGroupIds, partnerId, marketId) {
      return this._api.getOpportunityValueByAccountGroups({
        accountGroupIds: accountGroupIds,
        partnerId: partnerId,
        marketId: marketId
      }).pipe(map(resp => resp.results));
    }
    modifyActualCloseDateForOpportunity(requestParams) {
      return this._api.updateClosedDateForOpportunity({
        opportunityId: requestParams.opportunityId,
        accountGroupId: requestParams.accountGroupId,
        editSalesPersonId: requestParams.editSalesPersonId,
        closedDate: requestParams.closedDate
      });
    }
    updateOpportunityPipeline(opportunityId, accountGroupId, editSalesPersonId, pipelineId) {
      return this._api.updateOpportunityPipeline({
        opportunityId: opportunityId,
        accountGroupId: accountGroupId,
        editSalesPersonId: editSalesPersonId,
        pipelineId: pipelineId
      });
    }
    updateOpportunityProbability(opportunityId, accountGroupId, editSalesPersonId, probability) {
      return this._api.updateOpportunityProbability({
        opportunityId: opportunityId,
        accountGroupId: accountGroupId,
        editSalesPersonId: editSalesPersonId,
        probability: probability
      }).pipe(map(resp => resp.opportunity));
    }
    updateOpportunityType(opportunityId, accountGroupId, opportunityType, editSalesPersonId) {
      return this._api.updateOpportunityType({
        opportunityId: opportunityId,
        accountGroupId: accountGroupId,
        opportunityType: opportunityType,
        editSalesPersonId: editSalesPersonId
      }).pipe(map(resp => resp.opportunity));
    }
    updateOpportunityDuration(opportunityId, accountGroupId, editSalesPersonId, expectedContractDuration) {
      return this._api.updateOpportunityDuration({
        opportunityId,
        accountGroupId,
        editSalesPersonId,
        expectedContractDuration
      }).pipe(map(resp => resp.opportunity));
    }
    updateLineItemsForOpportunity(opportunityId, accountGroupId, editSalesPersonId, lineItems) {
      return this._api.updateLineItemsForOpportunity({
        opportunityId,
        accountGroupId,
        editSalesPersonId,
        lineItems
      }).pipe(map(resp => resp.opportunity));
    }
    updateSubscriberUserIdsForOpportunity(opportunityId, accountGroupId, editSalesPersonId, subscriberUserIds) {
      return this._api.updateSubscriberUserIDsForOpportunity({
        opportunityId,
        accountGroupId,
        editSalesPersonId,
        subscriberUserIds
      });
    }
    list(partnerId, marketId, filters, sortOption, searchTerm, pageSize, cursor) {
      return this._api.listOpportunities({
        partnerId: partnerId,
        marketId: marketId,
        filters: filters,
        sortOption: sortOption,
        searchTerm: searchTerm,
        pageSize: pageSize,
        cursor: cursor
      }).pipe(map(resp => {
        if (!!resp.results) {
          resp.results.forEach(r => {
            if (!r.pipelineId || r.pipelineId === '') {
              r.pipelineId = DEFAULT_PIPELINE_ID;
            }
          });
        }
        return resp;
      }));
    }
    reopenOpportunity(opportunityId, accountGroupId, salesPersonId, reason) {
      const request = {
        opportunityId: opportunityId,
        accountGroupId: accountGroupId,
        editSalesPersonId: salesPersonId,
        reason: reason
      };
      return this._api.reopenClosedOpportunity(request).pipe(map(response => {
        return response.status === 200;
      }));
    }
    closeOpportunityAsWon(opportunityId, accountGroupId, salesPersonId, notes) {
      const request = {
        opportunityId: opportunityId,
        accountGroupId: accountGroupId,
        editSalesPersonId: salesPersonId,
        notes: notes
      };
      return this._api.closeAsWonOpportunity(request).pipe(map(response => response.opportunity));
    }
    closeOpportunityAsLost(opportunityId, accountGroupId, salesPersonId, reason, notes) {
      const request = {
        opportunityId: opportunityId,
        accountGroupId: accountGroupId,
        editSalesPersonId: salesPersonId,
        reason: reason,
        notes: notes
      };
      return this._api.closeAsLostOpportunity(request).pipe(map(response => response.opportunity));
    }
    initiateOpportunityExport(partnerId, marketId, filters, sortOption, searchTerm, csvExports, csvOptions, clientOrigin) {
      const request = {
        partnerId: partnerId,
        marketId: marketId,
        filters: filters,
        sortOption: sortOption,
        searchTerm: searchTerm,
        csvFormatOptions: csvOptions,
        csvExports: csvExports,
        clientOrigin: clientOrigin
      };
      return this._api.initiateOpportunityExport(request).pipe(map(response => response.exportId));
    }
  }
  SalesOpportunitiesService.ɵfac = function SalesOpportunitiesService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalesOpportunitiesService)(i0.ɵɵinject(SalesOpportunitiesApiService));
  };
  SalesOpportunitiesService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesOpportunitiesService,
    factory: SalesOpportunitiesService.ɵfac,
    providedIn: 'root'
  });
  return SalesOpportunitiesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SalesPipelinesService = /*#__PURE__*/(() => {
  class SalesPipelinesService {
    constructor(_api) {
      this._api = _api;
    }
    createPipeline(partnerId, name, stages) {
      const request = {
        partnerId: partnerId,
        name: name,
        stages: stages
      };
      return this._api.createPipeline(request);
    }
    list(partnerId) {
      const request = {
        partnerId: partnerId
      };
      return this._api.listPipelines(request).pipe(map(resp => {
        return resp.results;
      }));
    }
    updatePipelineName(partnerId, pipelineId, name) {
      const request = {
        partnerId: partnerId,
        name: name,
        pipelineId: pipelineId
      };
      return this._api.updatePipelineName(request);
    }
    updatePipelineStageName(partnerId, pipelineId, stageId, stageName) {
      const request = {
        partnerId: partnerId,
        pipelineId: pipelineId,
        stageId: stageId,
        stageName: stageName
      };
      return this._api.updatePipelineStageName(request);
    }
    updatePipelineStageProbability(partnerId, pipelineId, stageId, probability) {
      const request = {
        partnerId: partnerId,
        pipelineId: pipelineId,
        stageId: stageId,
        probability: probability
      };
      return this._api.updatePipelineStageProbability(request);
    }
    addPipelineStages(partnerId, pipelineId, stages) {
      const request = {
        partnerId: partnerId,
        pipelineId: pipelineId,
        stages: stages
      };
      return this._api.addPipelineStages(request);
    }
    setPipelineStages(partnerId, pipelineId, stages) {
      const request = {
        partnerId: partnerId,
        pipelineId: pipelineId,
        stages: stages
      };
      return this._api.setPipelineStages(request);
    }
    removePipelineStages(partnerId, pipelineId, stageIds) {
      const request = {
        partnerId: partnerId,
        pipelineId: pipelineId,
        stageIds: stageIds
      };
      return this._api.removePipelineStages(request);
    }
    deletePipeline(partnerId, pipelineId) {
      const request = {
        partnerId: partnerId,
        pipelineId: pipelineId
      };
      return this._api.deletePipeline(request);
    }
  }
  SalesPipelinesService.ɵfac = function SalesPipelinesService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalesPipelinesService)(i0.ɵɵinject(SalesPipelinesApiService));
  };
  SalesPipelinesService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesPipelinesService,
    factory: SalesPipelinesService.ɵfac,
    providedIn: 'root'
  });
  return SalesPipelinesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OpportunityScoringService = /*#__PURE__*/(() => {
  class OpportunityScoringService {
    constructor(api, scoring) {
      this.api = api;
      this.scoring = scoring;
    }
    updateMEDDICScores(accountGroupId, opportunityId, meddicScores) {
      const req = {
        opportunityId: opportunityId,
        accountGroupId: accountGroupId,
        editSalesPersonId: '',
        metricScoreValue: meddicScores.metric,
        economicBuyerScoreValue: meddicScores.economicBuyer,
        decisionCriteriaScoreValue: meddicScores.decisionCriteria,
        decisionProcessScoreValue: meddicScores.decisionProcess,
        identifyPainScoreValue: meddicScores.identifyPain,
        championScoreValue: meddicScores.champion,
        competitionScoreValue: meddicScores.competition,
        paperProcessScoreValue: meddicScores.paperProcess
      };
      return this.scoring.updateMeddicScoringForOpportunity(req).pipe(take(1), mapTo(null));
    }
    getMEDDICScores(accountGroupId, opportunityId) {
      const req = {
        accountGroupId: accountGroupId,
        opportunityId: opportunityId
      };
      return this.scoring.getMeddicScores(req).pipe(map(response => ({
        metric: response.scores.metric || 0,
        economicBuyer: response.scores.economicBuyer || 0,
        decisionProcess: response.scores.decisionProcess || 0,
        decisionCriteria: response.scores.decisionCriteria || 0,
        identifyPain: response.scores.identifyPain || 0,
        champion: response.scores.champion || 0,
        competition: response.scores.competition || 0,
        paperProcess: response.scores.paperProcess || 0
      })));
    }
    updateMEDDICNotes(accountGroupId, opportunityId, editSalesPersonId, meddicSection, notes) {
      const req = {
        accountGroupId: accountGroupId,
        opportunityId: opportunityId,
        editSalesPersonId: editSalesPersonId,
        sectionName: meddicSection,
        sectionNotes: notes
      };
      return this.scoring.updateMeddicNotesForOpportunity(req).pipe(take(1), mapTo(null));
    }
    getMEDDICSections(accountGroupId, opportunityId) {
      const req = {
        accountGroupId: accountGroupId,
        opportunityId: opportunityId
      };
      return this.scoring.getMeddicSections(req).pipe(map(resp => {
        const sections = [];
        const scores = resp.sections.scores || [];
        scores.forEach(score => {
          const section = {
            sectionName: score.section,
            score: score.scoreValue || 0,
            notes: score.notes
          };
          sections.push(section);
        });
        return sections;
      }));
    }
  }
  OpportunityScoringService.ɵfac = function OpportunityScoringService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || OpportunityScoringService)(i0.ɵɵinject(SalesOpportunitiesApiService), i0.ɵɵinject(OpportunityScoringApiService));
  };
  OpportunityScoringService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: OpportunityScoringService,
    factory: OpportunityScoringService.ɵfac,
    providedIn: 'root'
  });
  return OpportunityScoringService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GoalsService = /*#__PURE__*/(() => {
  class GoalsService {
    constructor(_api) {
      this._api = _api;
    }
    create(createRequest) {
      return this._api.create(createRequest);
    }
    update(updateRequest) {
      return this._api.update(updateRequest);
    }
    list(listRequest) {
      return this._api.list(listRequest);
    }
    get(id) {
      const getRequest = {
        id: id
      };
      return this._api.get(getRequest);
    }
    delete(partnerId, id) {
      const deleteRequest = {
        id: id,
        partnerId: partnerId
      };
      return this._api.delete(deleteRequest);
    }
    archive(partnerId, id) {
      const archiveGoalRequest = {
        id: id,
        partnerId: partnerId
      };
      return this._api.archive(archiveGoalRequest);
    }
  }
  GoalsService.ɵfac = function GoalsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GoalsService)(i0.ɵɵinject(GoalsApiService));
  };
  GoalsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GoalsService,
    factory: GoalsService.ɵfac,
    providedIn: 'root'
  });
  return GoalsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CSVExports, CSVFormatOptions, ClientOrigin, CreateOpportunityRequest, CreateOpportunityRequestCreateOpportunityPackage, Currency, DateRangeFilter, Duration, DurationPeriod, GetTagsForOpportunitiesRequest, GoalType, GoalsService, LineItem, LineItemAppKey, ListOpportunitiesRequest, ListOpportunitiesRequestFilters, ListOpportunitiesRequestSortField, ListOpportunitiesRequestSortOption, ListOpportunitiesResponse, MEDDICSection, Opportunity, OpportunityCount, OpportunityRevenuePeriod, OpportunityScoringService, OpportunityValue, Package, Revenue, RevenueComponent, RevenuePeriod, RevenuePeriodFilter, SalesOpportunitiesApiService, SalesOpportunitiesService, SalesPipelinesService, Scoring, SortDirection, UpdateLineItemsRequest, UpdateLineItemsResponse };
